/* platform/index — Platform tier routes. */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RELEASE_FLAGS } from './releaseFlags';
import { usePlatformData } from './platformStore';
import PlatformLayout from './PlatformLayout';
import Dashboard from './Dashboard';
import Organizations from './Organizations';
import OrganizationDetail from './OrganizationDetail';
import PlatformAnalytics from './PlatformAnalytics';
import Partners from './Partners';
import AuditLogs from './AuditLogs';
import PlatformUsers from './PlatformUsers';
import PlatformUserDetail from './PlatformUserDetail';
import RolesPermissions from './RolesPermissions';
import Workspaces from './Workspaces';
import PlatformProfile from './PlatformProfile';
import PlatformSettings from './PlatformSettings';
import SystemHealth from './SystemHealth';
import ActivityTimeline from './ActivityTimeline';
import BackupRestore from './BackupRestore';
import ApiKeys from './ApiKeys';
import Plans from './Plans';

export default function PlatformRoutes() {
  const data = usePlatformData();
  return (
    <PlatformLayout data={data}>
      <Routes>
        <Route index element={<Dashboard data={data} />} />
        <Route path="plans" element={<Plans />} />
        <Route path="organizations" element={<Organizations data={data} />} />
        <Route path="organizations/:orgId" element={<OrganizationDetail data={data} />} />
        <Route path="analytics" element={<PlatformAnalytics data={data} />} />
        <Route path="partners" element={RELEASE_FLAGS.PARTNERS ? <Partners data={data} /> : <Navigate to="/platform" replace />} />
        <Route path="audit" element={<AuditLogs />} />
        <Route path="users" element={<PlatformUsers />} />
        <Route path="users/:userId" element={<PlatformUserDetail />} />
        <Route path="roles" element={<RolesPermissions />} />
        <Route path="workspaces" element={<Workspaces />} />
        <Route path="profile" element={<PlatformProfile />} />
        <Route path="settings" element={<PlatformSettings />} />
        <Route path="health" element={<SystemHealth />} />
        <Route path="timeline" element={<ActivityTimeline />} />
        <Route path="backup" element={<BackupRestore />} />
        <Route path="api-keys" element={RELEASE_FLAGS.API_KEYS ? <ApiKeys /> : <Navigate to="/platform" replace />} />
      </Routes>
    </PlatformLayout>
  );
}
